import { useMsal, useAccount } from '@azure/msal-react'
import type React from 'react'
import { useMemo, useEffect, useState, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'

import ctx from '@/context/AppContext'

interface Props {}

const Container = styled.div`
  display: grid;
  place-items: center;
  color: black;
  width: 100%;
  height: 100%;

  #success-container {
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      margin-right: 10px;
    }
  }
`

const HandleInvite: React.FC<Props> = props => {
  const [state, setState] = useState<'LOADING' | 'SUCCESS' | 'FAILED'>('LOADING')
  const { token, accessKey } = useContext(ctx)
  const { accounts } = useMsal()
  const history = useHistory()
  const account: any = useAccount(accounts[0] || [])

  const inviteId = useMemo(() => {
    const params = new URLSearchParams(window.location.search)

    return params.get('inviteId')
  }, [history]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!inviteId || !account?.idTokenClaims || !token) return
    const objectId = (account.idTokenClaims.oid as any) || ''
    const url = `${import.meta.env.VITE_SIGN_IN}/${objectId}/signIn?inviteCode=${inviteId}`

    fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Ocp-Apim-Subscription-Key': accessKey,
      },
    })
      .then(res => {
        if (res.status === 400) {
          setState('FAILED')
        } else {
          setState('SUCCESS')
          return res.json()
        }
      })
      .then(data => {
        history.push('/applicants')
      })
      .catch(err => {
        setState('FAILED')
      })
  }, [inviteId, account, token]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (state === 'SUCCESS') {
      setTimeout(() => {}, 1000)
    }
  }, [state])

  if (state === 'SUCCESS') {
    return (
      <Container>
        <div id="success-container">
          <img src="/assets/svg/circle-tick.svg" alt="circle with tick" />
          <p>Success! Your invite has been verified and you are good to go.</p>
        </div>
      </Container>
    )
  }

  if (state === 'LOADING') {
    return (
      <Container>
        <p>Checking Invite Code...</p>
      </Container>
    )
  }
  return (
    <Container>
      <div id="success-container">
        <img src="/assets/svg/fail.svg" alt="fail" />
        <p>
          Error! There was an issue completing your invite request. Please double check
          your URL and ensure it has been copied in its entireity.
        </p>
      </div>
    </Container>
  )
}

export default HandleInvite
